import Splide from '@splidejs/splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

function initCarousel(el) {
  if (!el || el.dataset.splideInit) return

  el.dataset.splideInit = '1'

  new Splide(el, {
    type: 'loop',
    speed: 1000,
    autoplay: el.dataset.autoplay === 'true',
    interval: parseInt(el.dataset.interval, 10) || 4000,
    pauseOnHover: true,
    arrows: true,
    pagination: true,
    flickMaxPages: 1
  }).mount()
}

// Play/pause videos when they enter/exit the viewport
const videoObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => {})
      } else {
        entry.target.pause()
      }
    })
  },
  { threshold: 0.1 }
)

function observeVideo(video) {
  if (video.dataset.autoplayInit) return

  video.dataset.autoplayInit = '1'
  video.muted = true
  videoObserver.observe(video)
}

function initMainFeature(root) {
  // Init for whole document on load, or re-rendered section in theme editor
  const scope = root && root.querySelectorAll ? root : document

  scope.querySelectorAll('.main-feature__carousel').forEach(initCarousel)
  scope.querySelectorAll('video[autoplay]').forEach((video) => {
    if (video.closest('.main-feature')) observeVideo(video)
  })
}

initMainFeature(document)

// Reinit when a section is re-rendered in the theme editor
document.addEventListener('shopify:section:load', (event) => {
  initMainFeature(event.target)
})
